<form class="app-flex-form" (click)="debugForm(constructor.name)" (keydown)="(null)">
  @for (filter of filters(); track $index) {
    @if (currentFilterView() === filter.label && filter.column === smsAdminFilterKey.Action) {
      <mat-selection-list [formField]="formTree.action">
        @for (action of smsActionValues; track $index) {
          <mat-list-option [value]="action" (click)="$event.stopPropagation()">
            {{ action | smsActionDisplay }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (currentFilterView() === filter.label && filter.column === smsAdminFilterKey.Tag) {
      <mat-selection-list [formField]="formTree.tag">
        @for (tag of smsTagValues; track $index) {
          <mat-list-option [value]="tag" (click)="$event.stopPropagation()">
            {{ tag | smsTagDisplay }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (currentFilterView() === filter.label && filter.column === smsAdminFilterKey.Status) {
      <mat-selection-list [formField]="formTree.status">
        @for (status of smsStatusValues; track $index) {
          <mat-list-option [value]="status" (click)="$event.stopPropagation()">
            {{ status | smsStatusDisplay }}
          </mat-list-option>
        }
      </mat-selection-list>
    }
  }
</form>
